import $http from './erpHttp';

// 权限菜单
export const authority = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/authority/' + '?' + id : '/v1/authority',
        method == 'get' ? { params: params } : params
    );
};


// 获取菜单
export const menu = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/menu/' + id : '/v1/menu',
        method == 'get' ? { params: params } : params
    );
};

// 设置菜单状态
export const menuSetStatus = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/menu/set-status/' + id : '/v1/menu/set-status',
        method == 'get' ? { params: params } : params
    );
};

// 获取菜单设置状态
export const menuGetStatus = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/menu/get-status/' + id : '/v1/menu/get-status',
        method == 'get' ? { params: params } : params
    );
};

// 菜单状态下拉
export const menuSelectStatus = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/menu/select-status/' + id : '/v1/menu/select-status',
        method == 'get' ? { params: params } : params
    );
};

// 菜单功能权限
export const getMenuAuth = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/menu/get-menu-auth/' + id : '/v1/menu/get-menu-auth',
        method == 'get' ? { params: params } : params
    );
};


// 创建角色
export const role = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/role/' + id : '/v1/role',
        method == 'get' ? { params: params } : params
    );
};


// 通知消息
export const notice = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/notice/' + id : '/v1/notice',
        method == 'get' ? { params: params } : params
    );
};

// 消息列表按钮显示
export const noticeRead = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/notice/read/' + id : '/v1/notice/read',
        method == 'get' ? { params: params } : params
    );
};

// 消息弹出列表
export const noticeTips = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/notice/tips/' + id : '/v1/notice/tips',
        method == 'get' ? { params: params } : params
    );
};

// 修改密码
export const changePwd = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/system/change-pwd/' + id : '/v1/system/change-pwd',
        method == 'get' ? { params: params } : params
    );
};

//配置信息公共接口
export const gconf = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/config/gconf/' + id : '/v1/config/gconf',
        method == 'get' ? { params: params } : params
    );
};

//配置信息公共接口(保存)
export const configSetting = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/config/setting/' + id : '/v1/config/setting',
        method == 'get' ? { params: params } : params
    );
};

// 店铺排行-更多
export const shopRank = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/home/shop-rank/' + id : '/v1/home/shop-rank',
        method == 'get' ? { params: params } : params
    );
};


// 各类数量统计
export const section1 = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/home/section1/' + id : '/v1/home/section1',
        method == 'get' ? { params: params } : params
    );
};

// 销量统计及店铺排行
export const section2 = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/home/section2/' + id : '/v1/home/section2',
        method == 'get' ? { params: params } : params
    );
};

// 设置角色
export const userSetRole = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/user/set-role/' + id : '/v1/user/set-role',
        method == 'get' ? { params: params } : params
    );
};

// 员工
export const user = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/user/' + id : '/v1/user',
        method == 'get' ? { params: params } : params
    );
};

// 获取员工列表
export const userSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/user/select' + id : '/v1/user/select',
        method == 'get' ? { params: params } : params
    );
};

// 创建产品分类
export const goodsCategory = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-category/' + id : '/v1/goods-category',
        method == 'get' ? { params: params } : params
    );
};

// 平台列表
export const platformNav = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/platform/nav/' + id : '/v1/platform/nav',
        method == 'get' ? { params: params } : params
    );
};

// 创建店铺
export const shop = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/shop/' + id : '/v1/shop',
        method == 'get' ? { params: params } : params
    );
};

// 国家列表
export const country = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/country/' + id : '/v1/country',
        method == 'get' ? { params: params } : params
    );
};

// 国家下拉列表
export const countrySelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/country/select/' + id : '/v1/country/select',
        method == 'get' ? { params: params } : params
    );
};

// 国家导入
export const countryImport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/country/import/' + id : '/v1/country/import',
        method == 'get' ? { params: params } : params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};
// 国家区域下拉
export const countryAreaSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/country-area/select/' + id : '/v1/country-area/select',
        method == 'get' ? { params: params } : params
    );
};

// 平台列表
export const platform = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/platform/' + id : '/v1/platform',
        method == 'get' ? { params: params } : params
    );
};

// 平台下拉列表
export const platformSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/platform/select/' + id : '/v1/platform/select',
        method == 'get' ? { params: params } : params
    );
};

// 店铺下拉列表
export const shopSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/shop/select/' + id : '/v1/shop/select',
        method == 'get' ? { params: params } : params
    );
};

// 平台导入
export const shopImport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/shop/import/' + id : '/v1/shop/import',
        method == 'get' ? { params: params } : params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};

// 平台sku
export const goodsSeller = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-seller/' + id : '/v1/goods-seller',
        method == 'get' ? { params: params } : params
    );
};


// 获取标签列表
export const goodsTag = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-tag/' + id : '/v1/goods-tag',
        method == 'get' ? { params: params } : params
    );
};

// 获取标签列表
export const goodsTagSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-tag/select' + id : '/v1/goods-tag/select',
        method == 'get' ? { params: params } : params
    );
};
// 获取属性列表
export const goodsAttr = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-attr/' + id : '/v1/goods-attr',
        method == 'get' ? { params: params } : params
    );
};

// 属性管理 -- 属性值列表
export const goodsAttrsValue = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-attrs-value/' + id : '/v1/goods-attrs-value',
        method == 'get' ? { params: params } : params
    );
};

// 汇率设置
export const currencyRate = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/currency-rate/' + id : '/v1/currency-rate',
        method == 'get' ? { params: params } : params
    );
};

// 汇率 - 批量删除
export const currencyRateBatchDel = (params, method, id) => {
    return $http[`${method}`](
        id
            ? '/v1/currency-rate/batch-del/' + id
            : '/v1/currency-rate/batch-del',
        method == 'get' ? { params: params } : params
    );
};

// 货币列表
export const currency = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/currency/' + id : '/v1/currency',
        method == 'get' ? { params: params } : params
    );
};

// 货币下拉
export const currencySelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/currency/select/' + id : '/v1/currency/select',
        method == 'get' ? { params: params } : params
    );
};

// 单位列表
export const goodsUnit = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-unit/' + id : '/v1/goods-unit',
        method == 'get' ? { params: params } : params
    );
};

// 单位列表
export const goodsUnitSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-unit/select/' + id : '/v1/goods-unit/select',
        method == 'get' ? { params: params } : params
    );
};

// 物流列表
export const expressChannel = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/express-channel/' + id : '/v1/express-channel',
        method == 'get' ? { params: params } : params
    );
};

// 单一产品创建
export const goods = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods/' + id : '/v1/goods',
        method == 'get' ? { params: params } : params
    );
};

// 获取产品语言设置
export const languageSet = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods/language-set/' + id : '/v1/goods/language-set',
        method == 'get' ? { params: params } : params
    );
};

// 选择属性
export const choiceAttr = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods/choice-attr/' + id : '/v1/goods/choice-attr',
        method == 'get' ? { params: params } : params
    );
};

// 店铺授权
export const shopAuth = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/shop/auth/' + id : '/v1/shop/auth',
        method == 'get' ? { params: params } : params
    );
};

// 订单列表
export const orders = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/orders/' + id : '/v1/orders',
        method == 'get' ? { params: params } : params
    );
};

// 订单列表 - 批量物流渠道
export const bchChannelCode = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/bch-channel-code/' + id : '/v1/order/bch-channel-code',
        method == 'get' ? { params: params } : params
    );
};

// 仓库列表
export const warehouse = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/warehouse/' + id : '/v1/warehouse',
        method == 'get' ? { params: params } : params
    );
};

// 仓库列表下拉
export const warehouseSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/warehouse/select/' + id : '/v1/warehouse/select',
        method == 'get' ? { params: params } : params
    );
};

// 物流渠道列表下拉
export const expressChannelSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/express-channel/select/' + id : '/v1/express-channel/select',
        method == 'get' ? { params: params } : params
    );
};

// 产品 sellerSku 导入
export const goodsSellerImport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-seller/import/' + id : '/v1/goods-seller/import',
        method == 'get' ? { params: params } : params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};

// 定制订单备注
export const orderGoodsRemark = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order-goods-remark/' + id : '/v1/order-goods-remark',
        method == 'get' ? { params: params } : params
    );
};

// 获取定制订单备注
export const getRemark = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/get-remark/' + id : '/v1/order/get-remark',
        method == 'get' ? { params: params } : params
    );
};

// 获取订单产品
export const getGoods = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/get-goods/' + id : '/v1/order/get-goods',
        method == 'get' ? { params: params } : params
    );
};

// 库存列表
export const inventory = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/inventory/' + id : '/v1/inventory',
        method == 'get' ? { params: params } : params
    );
};

// 库存导出
export const inventoryExport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/inventory/export/' + id : '/v1/inventory/export',
        method == 'get' ? { params: params } : params
    );
};

// 库存导入
export const inventoryImport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/inventory/import/' + id : '/v1/inventory/import',
        method == 'get' ? { params: params } : params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};

// 订单 - 修改地址
export const updateAddress = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/update-address/' + id : '/v1/order/update-address',
        method == 'get' ? { params: params } : params
    );
};

// 订单 - 标记异常
export const orderAbnormal = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/abnormal/' + id : '/v1/order/abnormal',
        method == 'get' ? { params: params } : params
    );
};

// 订单 - 取消订单
export const orderCancel = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/cancel/' + id : '/v1/order/cancel',
        method == 'get' ? { params: params } : params
    );
};

// 供应产列表
export const supplier = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/supplier/' + id : '/v1/supplier',
        method == 'get' ? { params: params } : params
    );
};

// 供应产列表
export const supplierSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/supplier/select/' + id : '/v1/supplier/select',
        method == 'get' ? { params: params } : params
    );
};

// 省市区三级联动
export const areaGetarealist = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/area/getarealist/' + id : '/v1/area/getarealist',
        method == 'get' ? { params: params } : params
    );
};

// 省市区三级联动
export const getAddress = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/get-address/' + id : '/v1/order/get-address',
        method == 'get' ? { params: params } : params
    );
};

// 询价查询
export const goodsQuotation = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-quotation/' + id : '/v1/goods-quotation',
        method == 'get' ? { params: params } : params
    );
};

// 产品询价
export const supplierQuotation = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-quotation/' + id : '/v1/goods-quotation',
        method == 'get' ? { params: params } : params
    );
};

// 询价导出
export const goodsQuotationExport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-quotation/export/' + id : '/v1/goods-quotation/export',
        method == 'get' ? { params: params } : params
    );
};

// 询价导入
export const goodsQuotationImport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-quotation/import/' + id : '/v1/goods-quotation/import',
        method == 'get' ? { params: params } : params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};

// 询价处理
export const goodsQuotation_handle = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-quotation/handle/' + id : '/v1/goods-quotation/handle',
        method == 'get' ? { params: params } : params
    );
};

// 询价确认
export const goodsQuotation_confirm = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-quotation/confirm/' + id : '/v1/goods-quotation/confirm',
        method == 'get' ? { params: params } : params
    );
};

// 询价取消
export const goodsQuotation_cancel = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-quotation/cancel/' + id : '/v1/goods-quotation/cancel',
        method == 'get' ? { params: params } : params
    );
};

// 询价驳回
export const goodsQuotation_reject = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-quotation/reject/' + id : '/v1/goods-quotation/reject',
        method == 'get' ? { params: params } : params
    );
};

// 询价通过
export const goodsQuotation_pass = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-quotation/pass/' + id : '/v1/goods-quotation/pass',
        method == 'get' ? { params: params } : params
    );
};

// 询价拒绝
export const goodsQuotation_refuse = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-quotation/refuse/' + id : '/v1/goods-quotation/refuse',
        method == 'get' ? { params: params } : params
    );
};

// 产品材质
export const goodsMaterial = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-material/' + id : '/v1/goods-material',
        method == 'get' ? { params: params } : params
    );
};

// 材质下拉
export const goodsMaterialSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-material/select/' + id : '/v1/goods-material/select',
        method == 'get' ? { params: params } : params
    );
};

// 定制翻译
export const customTranslation = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/custom-translation/' + id : '/v1/custom-translation',
        method == 'get' ? { params: params } : params
    );
};

// 新品调研
export const goodsDevelop = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop/' + id : '/v1/goods-develop',
        method == 'get' ? { params: params } : params
    );
};

// 新品 状态 => 处理
export const goodsDevelop_invest = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop/invest/' + id : '/v1/goods-develop/invest',
        method == 'get' ? { params: params } : params
    );
};

// 新品 状态 => 确认
export const goodsDevelop_confirm = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop/confirm/' + id : '/v1/goods-develop/confirm',
        method == 'get' ? { params: params } : params
    );
};

// 新品 状态 => 通过
export const goodsDevelop_pass = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop/pass/' + id : '/v1/goods-develop/pass',
        method == 'get' ? { params: params } : params
    );
};

// 新品 状态 => 淘汰
export const goodsDevelop_eliminate = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop/eliminate/' + id : '/v1/goods-develop/eliminate',
        method == 'get' ? { params: params } : params
    );
};

// 新品 状态 => 拒绝
export const goodsDevelop_refuse = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop/refuse/' + id : '/v1/goods-develop/refuse',
        method == 'get' ? { params: params } : params
    );
};

// 新品 状态 => 取消
export const goodsDevelop_cancel = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop/cancel/' + id : '/v1/goods-develop/cancel',
        method == 'get' ? { params: params } : params
    );
};

// 新品调研 导出
export const goodsDevelopExport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop/export/' + id : '/v1/goods-develop/export',
        method == 'get' ? { params: params } : params
    );
};

// 询价导入
export const goodsDevelopImport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop/import/' + id : '/v1/goods-develop/import',
        method == 'get' ? { params: params } : params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};

// 国家ID 获取对应货币
export const getCountryCurrency = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/country/get-country-currency/' + id : '/v1/country/get-country-currency',
        method == 'get' ? { params: params } : params
    );
};

// 开发模式下拉列表
export const goodsDevelopMode_basicMode = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop-mode/basic-mode/' + id : '/v1/goods-develop-mode/basic-mode',
        method == 'get' ? { params: params } : params
    );
};

// 开发模式列表
export const goodsDevelopMode = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop-mode/' + id : '/v1/goods-develop-mode',
        method == 'get' ? { params: params } : params
    );
};

// 开发模式列表下拉
export const goodsDevelopModeSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop-mode/select/' + id : '/v1/goods-develop-mode/select',
        method == 'get' ? { params: params } : params
    );
};

// 新品采样
export const goodsSample = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sample/' + id : '/v1/goods-sample',
        method == 'get' ? { params: params } : params
    );
};

// 采样导出
export const goodsSampleExport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sample/export/' + id : '/v1/goods-sample/export',
        method == 'get' ? { params: params } : params
    );
};

// 采样导入
export const goodsSampleImport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sample/import/' + id : '/v1/goods-sample/import',
        method == 'get' ? { params: params } : params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};

// 产品设计
export const goodsDesign = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-design/' + id : '/v1/goods-design',
        method == 'get' ? { params: params } : params
    );
};

// 设计导出
export const goodsDesignExport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-design/export/' + id : '/v1/goods-design/export',
        method == 'get' ? { params: params } : params
    );
};

// 设计导入
export const goodsDesignImport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-design/import/' + id : '/v1/goods-design/import',
        method == 'get' ? { params: params } : params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};

// 选择产品 - 产品询价
export const supplierQuotation_supplierGoods = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/supplier-quotation/supplier-goods/' + id : '/v1/supplier-quotation/supplier-goods',
        method == 'get' ? { params: params } : params
    );
};

// 选择产品 - 产品采样
export const goodsSample_sampleGoods = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sample/sample-goods/' + id : '/v1/goods-sample/sample-goods',
        method == 'get' ? { params: params } : params
    );
};

// 产品采样 - 处理
export const goodsSample_sampling = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sample/sampling/' + id : '/v1/goods-sample/sampling',
        method == 'get' ? { params: params } : params
    );
};

// 产品采样 - 确认
export const goodsSample_confirm = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sample/confirm/' + id : '/v1/goods-sample/confirm',
        method == 'get' ? { params: params } : params
    );
};

// 产品采样 - 通过
export const goodsSample_pass = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sample/pass/' + id : '/v1/goods-sample/pass',
        method == 'get' ? { params: params } : params
    );
};

// 产品采样 - 收货
export const goodsSample_arrival = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sample/arrival/' + id : '/v1/goods-sample/arrival',
        method == 'get' ? { params: params } : params
    );
};

// 产品采样 - 驳回
export const goodsSample_reject = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sample/reject/' + id : '/v1/goods-sample/reject',
        method == 'get' ? { params: params } : params
    );
};

// 产品采样 - 取消
export const goodsSample_cancel = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sample/cancel/' + id : '/v1/goods-sample/cancel',
        method == 'get' ? { params: params } : params
    );
};

// 产品采样 - 拒绝
export const goodsSample_refuse = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sample/refuse/' + id : '/v1/goods-sample/refuse',
        method == 'get' ? { params: params } : params
    );
};

// 产品设计 - 处理
export const goodsDesign_sampling = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-design/sampling/' + id : '/v1/goods-design/sampling',
        method == 'get' ? { params: params } : params
    );
};

// 产品设计 - 确认
export const goodsDesign_confirm = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-design/confirm/' + id : '/v1/goods-design/confirm',
        method == 'get' ? { params: params } : params
    );
};

// 产品设计 - 通过
export const goodsDesign_over = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-design/over/' + id : '/v1/goods-design/over',
        method == 'get' ? { params: params } : params
    );
};

// 产品设计 - 驳回
export const goodsDesign_reject = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-design/reject/' + id : '/v1/goods-design/reject',
        method == 'get' ? { params: params } : params
    );
};

// 产品设计 - 拒绝
export const goodsDesign_refuse = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-design/refuse/' + id : '/v1/goods-design/refuse',
        method == 'get' ? { params: params } : params
    );
};

// 产品设计 - 取消
export const goodsDesign_cancel = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-design/cancel/' + id : '/v1/goods-design/cancel',
        method == 'get' ? { params: params } : params
    );
};

// 产品设计 - 取消
export const goodsDesign_pass = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-design/pass/' + id : '/v1/goods-design/pass',
        method == 'get' ? { params: params } : params
    );
};

// 产品研发
export const goodsOpen = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-open/' + id : '/v1/goods-open',
        method == 'get' ? { params: params } : params
    );
};

// 产品研发 - 批量导入
export const goodsOpenImport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-open/import/' + id : '/v1/goods-open/import',
        method == 'get' ? { params: params } : params
    );
};

// 产品研发 - 批量导出
export const goodsOpenExport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-open/export/' + id : '/v1/goods-open/export',
        method == 'get' ? { params: params } : params
    );
};

// 产品研发 - 处理
export const goodsOpen_handle = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-open/handle/' + id : '/v1/goods-open/handle',
        method == 'get' ? { params: params } : params
    );
};

// 产品研发 - 确认
export const goodsOpen_confirm = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-open/confirm/' + id : '/v1/goods-open/confirm',
        method == 'get' ? { params: params } : params
    );
};

// 产品研发 - 通过
export const goodsOpen_pass = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-open/pass/' + id : '/v1/goods-open/pass',
        method == 'get' ? { params: params } : params
    );
};

// 产品研发 - 拒绝
export const goodsOpen_refuse = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-open/refuse/' + id : '/v1/goods-open/refuse',
        method == 'get' ? { params: params } : params
    );
};

// 产品研发 - 驳回
export const goodsOpen_reject = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-open/reject/' + id : '/v1/goods-open/reject',
        method == 'get' ? { params: params } : params
    );
};

// 产品研发 - 取消
export const goodsOpen_cancel = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-open/cancel/' + id : '/v1/goods-open/cancel',
        method == 'get' ? { params: params } : params
    );
};

// 产品完成
export const goodsComplete = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-complete/' + id : '/v1/goods-complete',
        method == 'get' ? { params: params } : params
    );
};

// 产品完成 - 批量导入
export const goodsCompleteImport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-complete/import/' + id : '/v1/goods-complete/import',
        method == 'get' ? { params: params } : params
    );
};

// 产品完成 - 批量导出
export const goodsCompleteExport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-complete/export/' + id : '/v1/goods-complete/export',
        method == 'get' ? { params: params } : params
    );
};

// 产品完成 - 处理
export const goodsComplete_sampling = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-complete/sampling/' + id : '/v1/goods-complete/sampling',
        method == 'get' ? { params: params } : params
    );
};

// 产品完成 - 通过
export const goodsComplete_pass = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-complete/pass/' + id : '/v1/goods-complete/pass',
        method == 'get' ? { params: params } : params
    );
};

// 产品完成 - 确认
export const goodsComplete_confirm = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-complete/confirm/' + id : '/v1/goods-complete/confirm',
        method == 'get' ? { params: params } : params
    );
};

// 产品完成 - 驳回
export const goodsComplete_reject = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-complete/reject/' + id : '/v1/goods-complete/reject',
        method == 'get' ? { params: params } : params
    );
};

// 产品完成 - 取消
export const goodsComplete_cancel = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-complete/cancel/' + id : '/v1/goods-complete/cancel',
        method == 'get' ? { params: params } : params
    );
};

// 产品完成 - 拒绝
export const goodsComplete_refuse = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-complete/refuse/' + id : '/v1/goods-complete/refuse',
        method == 'get' ? { params: params } : params
    );
};

// 产品完成 - tab 产品询价
export const goodsPrice = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-price/' + id : '/v1/goods-price',
        method == 'get' ? { params: params } : params
    );
};

// 产品列表 - 认领
export const goodsClaim = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods/claim/' + id : '/v1/goods/claim',
        method == 'get' ? { params: params } : params
    );
};

// 产品列表 - 取消认领
export const goodsCancelClaim = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods/cancel-claim/' + id : '/v1/goods/cancel-claim',
        method == 'get' ? { params: params } : params
    );
};

// 产品列表 - 上架
export const goodsOnShelf = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods/on-shelf/' + id : '/v1/goods/on-shelf',
        method == 'get' ? { params: params } : params
    );
};

// 产品列表 - 停售
export const goodsOffShelf = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods/off-shelf/' + id : '/v1/goods/off-shelf',
        method == 'get' ? { params: params } : params
    );
};

// 产品列表 - 淘汰
export const goodsOut = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods/out/' + id : '/v1/goods/out',
        method == 'get' ? { params: params } : params
    );
};

// 认领列表
export const claimList = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods/claim-list/' + id : '/v1/goods/claim-list',
        method == 'get' ? { params: params } : params
    );
};

// 生成多属性
export const attrCombin = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods/attr-combin/' + id : '/v1/goods/attr-combin',
        method == 'get' ? { params: params } : params
    );
};

// 信息维护
export const goodsInfo = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-info/' + id : '/v1/goods-info',
        method == 'get' ? { params: params } : params
    );
};

// 信息维护 - 处理
export const goodsInfo_sampling = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-info/sampling/' + id : '/v1/goods-info/sampling',
        method == 'get' ? { params: params } : params
    );
};

// 信息维护 - 确认
export const goodsInfo_confirm = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-info/confirm/' + id : '/v1/goods-info/confirm',
        method == 'get' ? { params: params } : params
    );
};

// 信息维护 - 通过
export const goodsInfo_pass = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-info/pass/' + id : '/v1/goods-info/pass',
        method == 'get' ? { params: params } : params
    );
};

// 信息维护 - 驳回
export const goodsInfo_reject = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-info/reject/' + id : '/v1/goods-info/reject',
        method == 'get' ? { params: params } : params
    );
};

// 信息维护 - 取消
export const goodsInfo_cancel = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-info/cancel/' + id : '/v1/goods-info/cancel',
        method == 'get' ? { params: params } : params
    );
};

// 信息维护 - 拒绝
export const goodsInfo_refuse = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-info/refuse/' + id : '/v1/goods-info/refuse',
        method == 'get' ? { params: params } : params
    );
};

// 采购计划列表
export const purchasePlan = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/purchase-plan/' + id : '/v1/purchase-plan',
        method == 'get' ? { params: params } : params
    );
};

// 采购单列表
export const purchaseOrders = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/purchase-orders/' + id : '/v1/purchase-orders',
        method == 'get' ? { params: params } : params
    );
};

// 采购单 - 获取产品接口
export const purchaseOrders_purchaseGoods = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/purchase-orders/purchase-goods/' + id : '/v1/purchase-orders/purchase-goods',
        method == 'get' ? { params: params } : params
    );
};

// 采购单 - 导入
export const purchaseOrdersImport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/purchase-orders/import/' + id : '/v1/purchase-orders/import',
        method == 'get' ? { params: params } : params
    );
};

// 采购单 - 导出
export const purchaseOrdersExport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/purchase-orders/export/' + id : '/v1/purchase-orders/export',
        method == 'get' ? { params: params } : params
    );
};

// 采购单 - 下单
export const purchaseOrdersOrder = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/purchase-orders/order/' + id : '/v1/purchase-orders/order',
        method == 'get' ? { params: params } : params
    );
};

// 运输承担方下拉
export const purchaseOrdersSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/purchase-orders/select/' + id : '/v1/purchase-orders/select',
        method == 'get' ? { params: params } : params
    );
};

// 产品价格
export const goodsAdmin_price = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-price/' + id : '/v1/goods-price',
        method == 'get' ? { params: params } : params
    );
};

// 新品淘汰
export const systemEliminate = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/system/eliminate/' + id : '/v1/system/eliminate',
        method == 'get' ? { params: params } : params
    );
};

// 产品 绑店
export const goodsBindShop = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods/bind-shop/' + id : '/v1/goods/bind-shop',
        method == 'get' ? { params: params } : params
    );
};

// 产品 测款
export const goodsTest = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-test/' + id : '/v1/goods-test',
        method == 'get' ? { params: params } : params
    );
};

// 产品 导入
export const goodsTestImport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-test/import/' + id : '/v1/goods-test/import',
        method == 'get' ? { params: params } : params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};

// 产品 处理
export const goodsTest_sampling = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-test/sampling/' + id : '/v1/goods-test/sampling',
        method == 'get' ? { params: params } : params
    );
};

// 产品 确认
export const goodsTest_confirm = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-test/confirm/' + id : '/v1/goods-test/confirm',
        method == 'get' ? { params: params } : params
    );
};

// 产品 通过
export const goodsTest_pass = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-test/pass/' + id : '/v1/goods-test/pass',
        method == 'get' ? { params: params } : params
    );
};

// 产品 驳回
export const goodsTest_reject = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-test/reject/' + id : '/v1/goods-test/reject',
        method == 'get' ? { params: params } : params
    );
};

// 产品 取消
export const goodsTest_cancel = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-test/cancel/' + id : '/v1/goods-test/cancel',
        method == 'get' ? { params: params } : params
    );
};

// 产品 拒绝
export const goodsTest_refuse = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-test/refuse/' + id : '/v1/goods-test/refuse',
        method == 'get' ? { params: params } : params
    );
};

// 调研 回退
export const goodsDevelop_backoff = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop/back-off/' + id : '/v1/goods-develop/back-off',
        method == 'get' ? { params: params } : params
    );
};

// 研发 回退
export const goodsOpen_backoff = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-open/back-off/' + id : '/v1/goods-open/back-off',
        method == 'get' ? { params: params } : params
    );
};

// 测款 回退
export const goodsTest_backoff = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-test/back-off/' + id : '/v1/goods-test/back-off',
        method == 'get' ? { params: params } : params
    );
};

// 维护 回退
export const goodsInfo_backoff = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-info/back-off/' + id : '/v1/goods-info/back-off',
        method == 'get' ? { params: params } : params
    );
};

// 询价 回退
export const supplierQuotation_backoff = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/supplier-quotation/back-off/' + id : '/v1/supplier-quotation/back-off',
        method == 'get' ? { params: params } : params
    );
};

// 维护 回退
export const goodsSample_backoff = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sample/back-off/' + id : '/v1/goods-sample/back-off',
        method == 'get' ? { params: params } : params
    );
};

// 设计 回退
export const goodsDesign_backoff = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-design/back-off/' + id : '/v1/goods-design/back-off',
        method == 'get' ? { params: params } : params
    );
};

// 完成 回退
export const goodsComplete_backoff = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-complete/backoff/' + id : '/v1/goods-complete/back-off',
        method == 'get' ? { params: params } : params
    );
};

// ASN送货单
export const asn = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/asn/' + id : '/v1/asn',
        method == 'get' ? { params: params } : params
    );
};

// ASN送货单 -- 确认
export const asnSampling = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/asn/sampling/' + id : '/v1/asn/sampling',
        method == 'get' ? { params: params } : params
    );
};

// ASN送货单 -- 通过
export const asnDesigned = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/asn/designed/' + id : '/v1/asn/designed',
        method == 'get' ? { params: params } : params
    );
};

// ASN送货单 -- 拒绝
export const asnRefuse = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/asn/refuse/' + id : '/v1/asn/refuse',
        method == 'get' ? { params: params } : params
    );
};

// ASN送货单 -- 取消
export const asnCancel = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/asn/cancel/' + id : '/v1/asn/cancel',
        method == 'get' ? { params: params } : params
    );
};

// ASN送货单 导入
export const asnImport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/asn/import/' + id : '/v1/asn/import',
        method == 'get' ? { params: params } : params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};

// ASN送货单 导出
export const asnExport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/asn/export/' + id : '/v1/asn/export',
        method == 'get' ? { params: params } : params
    );
};

// ASN 产品信息
export const asnGoods = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/asn/asn-goods/' + id : '/v1/asn/asn-goods',
        method == 'get' ? { params: params } : params
    );
};

// 采购单 确认
export const purchaseOrders_sampling = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/purchase-orders/sampling/' + id : '/v1/purchase-orders/sampling',
        method == 'get' ? { params: params } : params
    );
};

// 采购单 通过
export const purchaseOrders_placed = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/purchase-orders/placed/' + id : '/v1/purchase-orders/placed',
        method == 'get' ? { params: params } : params
    );
};

// 采购单 拒绝
export const purchaseOrders_refuse = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/purchase-orders/refuse/' + id : '/v1/purchase-orders/refuse',
        method == 'get' ? { params: params } : params
    );
};

// 采购单 取消
export const purchaseOrders_cancel = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/purchase-orders/cancel/' + id : '/v1/purchase-orders/cancel',
        method == 'get' ? { params: params } : params
    );
};

// 模式权限
export const goodsDevelopMode_authToUser = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop-mode/auth-to-user/' + id : '/v1/goods-develop-mode/auth-to-user',
        method == 'get' ? { params: params } : params
    );
};

// 模式权限 -- 修改
export const goodsDevelopMode_getAuth = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop-mode/get-auth/' + id : '/v1/goods-develop-mode/get-auth',
        method == 'get' ? { params: params } : params
    );
};

// 任务列表
export const tasks = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/tasks/' + id : '/v1/tasks',
        method == 'get' ? { params: params } : params
    );
};

// 任务数量
export const tasksCount = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/tasks/count/' + id : '/v1/tasks/count',
        method == 'get' ? { params: params } : params
    );
};

// 认领
export const tasksRecept = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/tasks/recept/' + id : '/v1/tasks/recept',
        method == 'get' ? { params: params } : params
    );
};

// 根据链接获取产品信息
export const thirdParty_one688 = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/third-party/one688/' + id : '/v1/third-party/one688',
        method == 'get' ? { params: params } : params
    );
};

// 我的任务 - 新品详情查询
// 研发
export const goodsOpen_tasksGoods = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-open/task-goods/' + id : '/v1/goods-open/task-goods',
        method == 'get' ? { params: params } : params
    );
};
// 询价
export const supplierQuotation_tasksGoods = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/supplier-quotation/task-goods/' + id : '/v1/supplier-quotation/task-goods',
        method == 'get' ? { params: params } : params
    );
};
// 采样
export const goodsSample_tasksGoods = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sample/task-goods/' + id : '/v1/goods-sample/task-goods',
        method == 'get' ? { params: params } : params
    );
};
// 设计
export const goodsDesign_tasksGoods = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-design/task-goods/' + id : '/v1/goods-design/task-goods',
        method == 'get' ? { params: params } : params
    );
};

// 测款
export const goodsTest_tasksGoods = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-test/task-goods/' + id : '/v1/goods-test/task-goods',
        method == 'get' ? { params: params } : params
    );
};

// 信息
export const goodsInfo_tasksGoods = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-info/task-goods/' + id : '/v1/goods-info/task-goods',
        method == 'get' ? { params: params } : params
    );
};

// 完成
export const goodsComplete_tasksGoods = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-complete/task-goods/' + id : '/v1/goods-complete/task-goods',
        method == 'get' ? { params: params } : params
    );
};

// 新品 - 淘汰
// 研发
export const goodsOpen_eliminate = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-open/eliminate/' + id : '/v1/goods-open/eliminate',
        method == 'get' ? { params: params } : params
    );
};

// 询价
export const supplierQuotation_eliminate = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/supplier-quotation/eliminate/' + id : '/v1/supplier-quotation/eliminate',
        method == 'get' ? { params: params } : params
    );
};
// 采样
export const goodsSample_eliminate = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sample/eliminate/' + id : '/v1/goods-sample/eliminate',
        method == 'get' ? { params: params } : params
    );
};
// 设计
export const goodsDesign_eliminate = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-design/eliminate/' + id : '/v1/goods-design/eliminate',
        method == 'get' ? { params: params } : params
    );
};

// 测款
export const goodsTest_eliminate = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-test/eliminate/' + id : '/v1/goods-test/eliminate',
        method == 'get' ? { params: params } : params
    );
};

// 信息
export const goodsInfo_eliminate = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-info/eliminate/' + id : '/v1/goods-info/eliminate',
        method == 'get' ? { params: params } : params
    );
};

// 完成
export const goodsComplete_eliminate = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-complete/eliminate/' + id : '/v1/goods-complete/eliminate',
        method == 'get' ? { params: params } : params
    );
};
// 新品 - 释放

// 新品
export const goodsDevelop_release = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop/release/' + id : '/v1/goods-develop/release',
        method == 'get' ? { params: params } : params
    );
};
// 研发
export const goodsOpen_release = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-open/release/' + id : '/v1/goods-open/release',
        method == 'get' ? { params: params } : params
    );
};

// 询价
export const supplierQuotation_release = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/supplier-quotation/release/' + id : '/v1/supplier-quotation/release',
        method == 'get' ? { params: params } : params
    );
};
// 采样
export const goodsSample_release = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sample/release/' + id : '/v1/goods-sample/release',
        method == 'get' ? { params: params } : params
    );
};
// 设计
export const goodsDesign_release = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-design/release/' + id : '/v1/goods-design/release',
        method == 'get' ? { params: params } : params
    );
};

// 测款
export const goodsTest_release = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-test/release/' + id : '/v1/goods-test/release',
        method == 'get' ? { params: params } : params
    );
};

// 信息
export const goodsInfo_release = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-info/release/' + id : '/v1/goods-info/release',
        method == 'get' ? { params: params } : params
    );
};

// 完成
export const goodsComplete_release = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-complete/release/' + id : '/v1/goods-complete/release',
        method == 'get' ? { params: params } : params
    );
};


// 完成
export const goodsTest_goodsData = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-test/goods-data/' + id : '/v1/goods-test/goods-data',
        method == 'get' ? { params: params } : params
    );
};


// 产品绑店
export const goodsSell = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sell/' + id : '/v1/goods-sell',
        method == 'get' ? { params: params } : params
    );
};

// 产品绑店 - 解绑
export const goodsSell_unbind = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-sell/unbind/' + id : '/v1/goods-sell/unbind',
        method == 'get' ? { params: params } : params
    );
};

// 产品成本 
export const goodsCost = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-cost/' + id : '/v1/goods-cost',
        method == 'get' ? { params: params } : params
    );
};

// 产品成本  - 批量修改成本
export const goodsCost_batchUpdate = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-cost/batch-update/' + id : '/v1/goods-cost/batch-update',
        method == 'get' ? { params: params } : params
    );
};

// 产品下拉
export const goodsSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods/select/' + id : '/v1/goods/select',
        method == 'get' ? { params: params } : params
    );
};

// 订单标签列表
export const orderTag = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order-tag/' + id : '/v1/order-tag',
        method == 'get' ? { params: params } : params
    );
};

// 标签颜色下拉
export const colorSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/color/select/' + id : '/v1/color/select',
        method == 'get' ? { params: params } : params
    );
};

// 标签下拉
export const orderTagSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order-tag/select/' + id : '/v1/order-tag/select',
        method == 'get' ? { params: params } : params
    );
};

// 订单产品添加标签
export const orderSetTags = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/set-tags/' + id : '/v1/order/set-tags',
        method == 'get' ? { params: params } : params
    );
};

// 删除订单产品标签
export const orderCancelTags = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/cancel-tags/' + id : '/v1/order/cancel-tags',
        method == 'get' ? { params: params } : params
    );
};

// 订单产品获取标签
export const orderGetTags = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/get-tags/' + id : '/v1/order/get-tags',
        method == 'get' ? { params: params } : params
    );
};

// 产品包装
export const goodsPackbox = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-packbox/' + id : '/v1/goods-packbox',
        method == 'get' ? { params: params } : params
    );
};

// 产品包装下拉
export const goodsPackboxSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-packbox/select/' + id : '/v1/goods-packbox/select',
        method == 'get' ? { params: params } : params
    );
};

// 产品包装下拉
export const goodsCancel = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods/cancel/' + id : '/v1/goods/cancel',
        method == 'get' ? { params: params } : params
    );
};

// 产品包装下拉
export const download = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/download/' + id : '/v1/download',
        method == 'get' ? { params: params } : params
    );
};

// 定制图片
export const setMadeImage = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/set-made-image/' + id : '/v1/order/set-made-image',
        method == 'get' ? { params: params } : params
    );
};

// 获取定制图片
export const getMadeImage = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/get-made-image/' + id : '/v1/order/get-made-image',
        method == 'get' ? { params: params } : params
    );
};

// 添加备注
export const setGoodsRemark = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/set-goods-remark/' + id : '/v1/order/set-goods-remark',
        method == 'get' ? { params: params } : params
    );
};

// 获取备注
export const getGoodsRemark = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/get-goods-remark/' + id : '/v1/order/get-goods-remark',
        method == 'get' ? { params: params } : params
    );
};

// 产品图库组的创建
export const goodsImageGroup = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-image-group/' + id : '/v1/goods-image-group',
        method == 'get' ? { params: params } : params
    );
};

// 图片库 -- 获取图片
export const goodsImage = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-image/' + id : '/v1/goods-image',
        method == 'get' ? { params: params } : params
    );
};

// 产品包装分类创建
export const goodsPackboxCategory = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-packbox-category/' + id : '/v1/goods-packbox-category',
        method == 'get' ? { params: params } : params
    );
};

// 产品包装分类下拉
export const goodsPackboxCategorySelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-packbox-category/select/' + id : '/v1/goods-packbox-category/select',
        method == 'get' ? { params: params } : params
    );
};

// 图库图片导出
export const goodsImageExport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-image/export/' + id : '/v1/goods-image/export',
        method == 'get' ? { params: params } : params
    );
};

// 下载文件
export const downloadReal = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/download/real/' + id : '/v1/download/real',
        method == 'get' ? { params: params } : params
    );
};

// 客户管理
export const customer = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/customer/' + id : '/v1/customer',
        method == 'get' ? { params: params } : params
    );
};

// 客户管理 类型下拉
export const customerSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/customer/select/' + id : '/v1/customer/select',
        method == 'get' ? { params: params } : params
    );
};

// 新品测款 获取3 7 14 30天测款数据
export const goodsTest_census = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-test/census/' + id : '/v1/goods-test/census',
        method == 'get' ? { params: params } : params
    );
};

// CRM 客户信息 够买详情
export const customerOrder = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/customer/customer-order/' + id : '/v1/customer/customer-order',
        method == 'get' ? { params: params } : params
    );
};

// CRM 客户信息 够买详情
export const customerImport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/customer/import/' + id : '/v1/customer/import',
        method == 'get' ? { params: params } : params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};

// 客户信息导出
export const customerExport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/customer/export/' + id : '/v1/customer/export',
        method == 'get' ? { params: params } : params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};

// 送货单编辑物流信息
export const asnUpdateFree = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/asn/update-free/' + id : '/v1/asn/update-free',
        method == 'get' ? { params: params } : params
    );
};

// 送货单编辑物流信息
export const goodsImage_swapGroup = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-image/swap-group/' + id : '/v1/goods-image/swap-group',
        method == 'get' ? { params: params } : params
    );
};

// 客户信息操作日志
export const customerShowLog = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/customer/show-log/' + id : '/v1/customer/show-log',
        method == 'get' ? { params: params } : params
    );
};

// 预警列表
export const trackWarning = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/track-warning/' + id : '/v1/track-warning',
        method == 'get' ? { params: params } : params
    );
};

// 批量添加物流单号
export const trackWarning_batchAdd = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/track-warning/batch-add/' + id : '/v1/track-warning/batch-add',
        method == 'get' ? { params: params } : params
    );
};

//预警导出
export const trackExport = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/track-warning/export/' + id : '/v1/track-warning/export',
        method == 'get' ? { params: params } : params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};

// 预警统计
export const trackWarningStat = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/track-warning/stat/' + id : '/v1/track-warning/stat',
        method == 'get' ? { params: params } : params
    );
};

// 物流查询
export const trackWarningQuery = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/track-warning/query/' + id : '/v1/track-warning/query',
        method == 'get' ? { params: params } : params
    );
};

// 邮件发送列表 
export const email = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/email/' + id : '/v1/email',
        method == 'get' ? { params: params } : params
    );
};

// 邮箱设置下拉
export const setEmailSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/set-email/select/' + id : '/v1/set-email/select',
        method == 'get' ? { params: params } : params
    );
};

// 邮箱设置
export const setEmail = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/set-email/' + id : '/v1/set-email',
        method == 'get' ? { params: params } : params
    );
};

// 邮件发送
export const emailDo = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/email/do/' + id : '/v1/email/do',
        method == 'get' ? { params: params } : params
    );
};

// 邮件取消
export const emailCancel = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/email/cancel/' + id : '/v1/email/cancel',
        method == 'get' ? { params: params } : params
    );
};

// 邮件取消
export const customerStatsMain = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/customer-stats/main/' + id : '/v1/customer-stats/main',
        method == 'get' ? { params: params } : params
    );
};

// 客户统计--客户销售额柱状图
export const customerStatsOrder = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/customer-stats/order/' + id : '/v1/customer-stats/order',
        method == 'get' ? { params: params } : params
    );
};

// 客户统计--销售额排行--更多
export const customerStats_saleRanking = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/customer-stats/sale-ranking/' + id : '/v1/customer-stats/sale-ranking',
        method == 'get' ? { params: params } : params
    );
};

// 客户统计--发邮件排行--更多
export const customerStats_saleEmailRanking = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/customer-stats/send-email-ranking/' + id : '/v1/customer-stats/send-email-ranking',
        method == 'get' ? { params: params } : params
    );
};

// 供应商询价插入（new）
export const goodsQuotationDetail = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-quotation-detail/' + id : '/v1/goods-quotation-detail',
        method == 'get' ? { params: params } : params
    );
};

// 新品询价 - 查看
export const goodsQuotationDetail_findQuotation = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-quotation-detail/find-quotation/' + id : '/v1/goods-quotation-detail/find-quotation',
        method == 'get' ? { params: params } : params
    );
};


// 供应商询价 - 查看
export const goodsQuotationDetail_defaultQuotation = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-quotation-detail/default-quotation/' + id : '/v1/goods-quotation-detail/default-quotation',
        method == 'get' ? { params: params } : params
    );
};

// CRM管理 - 客户 - 批量
export const customerBatchUpdate  = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/customer/batch-update/' + id : '/v1/customer/batch-update',
        method == 'get' ? { params: params } : params
    );
};

// 新品管理 - 新品询价 - 确认（编辑）获取产品数据
export const goodsFindAttributes  = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods/find-attributes/' + id : '/v1/goods/find-attributes',
        method == 'get' ? { params: params } : params
    );
};

// 新品管理 - 新品调研 - 设置新品成本
export const goodsDevelop_setCostAttr  = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-develop/set-cost-attr/' + id : '/v1/goods-develop/set-cost-attr',
        method == 'get' ? { params: params } : params
    );
};

// 获取跟进客户信息
export const customer_findFollowData  = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/customer/find-follow-data/' + id : '/v1/customer/find-follow-data',
        method == 'get' ? { params: params } : params
    );
};

// 标星或取消标星
export const emailStar = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/email/star/' + id : '/v1/email/star',
        method == 'get' ? { params: params } : params
    );
};

// 新建邮件标签
export const emailTags = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/email-tags/' + id : '/v1/email-tags',
        method == 'get' ? { params: params } : params
    );
};

// 新建邮件标签下拉
export const emailTagsSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/email-tags/select/' + id : '/v1/email-tags/select',
        method == 'get' ? { params: params } : params
    );
};

// 邮件标记标签
export const email_batchTags = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/email/batch-tags/' + id : '/v1/email/batch-tags',
        method == 'get' ? { params: params } : params
    );
};

// 删除邮件标签
export const email_deleteTags = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/email/delete-tags/' + id : '/v1/email/delete-tags',
        method == 'get' ? { params: params } : params
    );
};

// 物流渠道
export const carriersExpress = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/carriers-express/' + id : '/v1/carriers-express',
        method == 'get' ? { params: params } : params
    );
};

// 物流渠道下拉
export const carriersExpress_select = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/carriers-express/select/' + id : '/v1/carriers-express/select',
        method == 'get' ? { params: params } : params
    );
};

// 订单合并
export const orderCombine = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/combine/' + id : '/v1/order/combine',
        method == 'get' ? { params: params } : params
    );
};

// 订单合并
export const orderCombineSelect = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/combine-select/' + id : '/v1/order/combine-select',
        method == 'get' ? { params: params } : params
    );
};

// 订单取消合并
export const orderUncombine = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/uncombine/' + id : '/v1/order/uncombine',
        method == 'get' ? { params: params } : params
    );
};

// 订单重发
export const orderRedeliver = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/redeliver/' + id : '/v1/order/redeliver',
        method == 'get' ? { params: params } : params
    );
};

// 订单 - 销售审核
export const orderCheck = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/check/' + id : '/v1/order/check',
        method == 'get' ? { params: params } : params
    );
};

// 订单 - 转待发货
export const changeOrderStatus = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/change-status/' + id : '/v1/order/change-status',
        method == 'get' ? { params: params } : params
    );
};

// 物流规则
export const expressRule = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/express-rule/' + id : '/v1/express-rule',
        method == 'get' ? { params: params } : params
    );
};

// 订单拆分
export const orderResolution = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/resolution/' + id : '/v1/order/resolution',
        method == 'get' ? { params: params } : params
    );
};

// 获取商品属性列表信息
export const goodsAttribute = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods/attribute/' + id : '/v1/goods/attribute',
        method == 'get' ? { params: params } : params
    );
};

// 店铺绑定包装
export const goodsPackboxShop = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-packbox-shop/' + id : '/v1/goods-packbox-shop',
        method == 'get' ? { params: params } : params
    );
};

// 获取店铺绑定包装
export const goodsPackboxShop_findBind = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/goods-packbox-shop/find-bind/' + id : '/v1/goods-packbox-shop/find-bind',
        method == 'get' ? { params: params } : params
    );
};

// 地址库
export const address = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/address/' + id : '/v1/address',
        method == 'get' ? { params: params } : params
    );
};

//绑定发货退货地址
export const warehouseBindAddress = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/warehouse/bind-address/' + id : '/v1/warehouse/bind-address',
        method == 'get' ? { params: params } : params
    );
};

// 设置产品定制信息
export const setMadeDesc = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/set-made-desc/' + id : '/v1/order/set-made-desc',
        method == 'get' ? { params: params } : params
    );
};

// 获取产品定制信息
export const getMadeDesc = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/get-made-desc/' + id : '/v1/order/get-made-desc',
        method == 'get' ? { params: params } : params
    );
};

// USPS导入
export const orderImportTrackno = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/import-trackno/' + id : '/v1/order/import-trackno',
        method == 'get' ? { params: params } : params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};

// USPS导出
export const orderExportAddress = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/export-address/' + id : '/v1/order/export-address',
        method == 'get' ? { params: params } : params
    );
};

// USPS-ST导出
export const orderExportAddress2 = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/export-address2/' + id : '/v1/order/export-address2',
        method == 'get' ? { params: params } : params
    );
};

// 创建订单商标映射
export const ordersTagsShop = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/orders-tags-shop/' + id : '/v1/orders-tags-shop',
        method == 'get' ? { params: params } : params
    );
};

// 创建订单商标映射
export const ordersRemark = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/orders-remark/' + id : '/v1/orders-remark',
        method == 'get' ? { params: params } : params
    );
};

// 重新预报
export const orderRePrediction = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/re-prediction/' + id : '/v1/order/re-prediction',
        method == 'get' ? { params: params } : params
    );
};

// 订单包装设置
export const shopPackbox = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/shop-packbox/' + id : '/v1/shop-packbox',
        method == 'get' ? { params: params } : params
    );
};

// 主页
export const home = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/home/' + id : '/v1/home',
        method == 'get' ? { params: params } : params
    );
};

// 订单加急
export const orderUrgent = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/order/urgent/' + id : '/v1/order/urgent',
        method == 'get' ? { params: params } : params
    );
};